import React, { useState, useEffect } from "react";

import Web3 from "web3";
import Market from "../../abi/marketplace.json";
import { Link } from "react-router-dom";
import copy from "copy-to-clipboard";
// Stylesheet
import "./SingleNFT.css";

// Assets
import ethereum from "../../assets/ethereum.png";
import polygon from "../../assets/matic.svg";

import ls from "localstorage-slim";

// Components
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// Material UI Icons
import { Menu, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import { ClipLoader } from "react-spinners";

import {
  FacebookShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
} from "react-share";

import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import PreloaderInner from "./../../components/preloader/loader";
import firebase from "./../../firebase";
import { useDispatch, useSelector } from "react-redux";
import { authFeatureKey } from "../../store/featureKeys";
import * as authActions from "../../store/actions/authActions";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { maticToWei } from "../utils/PriceUtils";

const web3 = new Web3(window.ethereum);

function SingleNFTInfluencer() {
  let location = window.location.href;
  let { ipfsHash, influencer } = useParams();
  let shareUrl = `${location}`;
  const [NFTDetail, setNFTDetail] = useState({});

  useEffect(() => {
    console.log("ipfsHash=>>>", ipfsHash);
    console.log("NFTDetail=>>>", NFTDetail);
  }, []);
  const [display, setDisplay] = useState("arrow");
  const [align, setAlign] = useState("center");
  const [position, setPosition] = useState("anchor");
  const [viewScroll, setViewScroll] = useState("auto");
  const [direction, setDirection] = useState("left");
  const [spinner, setSpinner] = React.useState(false);

  const [views, setViews] = useState(0);
  const [likes, setLikes] = useState(0);
  const [username, setUserName] = useState("");
  const [loader, setLoader] = useState(true);
  const [creatorAddress, setCreatorAddress] = useState("");
  const [userAddress, setUserAddress] = useState("");
  const [account, setAccount] = React.useState("");
  const auth = useSelector((state) => {
    return state[authFeatureKey];
  });
  let currentUser = auth.currentUser;
  let hideBuyNowIfCreator = () => {
    if (currentUser === creatorAddress) {
      return true;
    }
    return false;
  };
  React.useEffect(async () => {
    const { ethereum } = window;
    const web3 = new Web3(ethereum);
    const a = await web3.eth.getAccounts();
    if (a != account) {
      setAccount(a);
    }
  }, [account]);

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    if (ipfsHash && !creatorAddress) {
      firebase
        .firestore()
        .collection("NFTDataModel")
        .where("ipfsHash", "==", ipfsHash)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            let detail = doc.data();
            detail.docID = doc.id;
            setNFTDetail(detail);
            setViews(detail.views);
            setLikes(detail.likes);
            setCreatorAddress(detail.creatorAddress);
            let updatedObj = { ...detail };
            updatedObj.views = detail.views + 1;
            updatedObj.score = detail.score + 1;
            doc.ref.update(updatedObj);
          });
        });
    }
  };
  async function setNftSold(nft, useraddr) {
    let newInfluenceCollection = JSON.parse(NFTDetail.influenceCollection);
    newInfluenceCollection.forEach((element) => {
      if (element.uniqueID === influencer) {
        element.isSold = true;
      }
    });
    await firebase
      .firestore()
      .collection("NFTDataModel")
      .doc(nft.docID)
      .update({
        sold: true,
        ownerAddress: useraddr[0],
        influenceCollection: JSON.stringify(newInfluenceCollection),
      });
  }
  useEffect(() => {
    if (creatorAddress) {
      firebase
        .firestore()
        .collection("UserDataModel")
        .limit(1)
        .where("walletAddress", "==", `${creatorAddress}`)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            // doc.data() is never undefined for query doc snapshots
            const userDetail = doc.data();
            setUserAddress(userDetail.walletAddress);
            if (userDetail.username) {
              setUserName(userDetail.username);
              setLoader(false);
            }
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
          setLoader(false);
        });
    }
  }, [creatorAddress]);

  // var TOKEN_Contract = new web3.eth.Contract(
  //   Mock,
  //   "0x6c1476670d186bc734ffa3de5e3c4f5a0f5331db" // wrap ether address
  // );

  const buyNFT = async (currentNft) => {
    try {
      setLoader(true);
      if (
        currentNft.chain === "Ethereum" &&
        window.ethereum.networkVersion === "4"
      ) {
        console.log(currentNft.chain);
        const account = await web3.eth.getAccounts();
        console.log(account);
        const Marketcontract = new web3.eth.Contract(
          Market,
          "0xa25eEB08e07B6727248b8071d308bE594C28398a" // change mainnet market address over here
        );
        console.log(Marketcontract);
        const price = web3.utils.toWei(`${currentNft.price}`, "ether");
        console.log(price);
        const transaction = await Marketcontract.methods
          .createMarketSale(
            "0xE3F7E379d8D434ba1cab6E70447DD2EBBB93C272", // replace mainnet nft address over here
            currentNft.tokenid
          )
          .send({ from: `${account[0]}`, value: price });
        console.log(transaction);
        setNftSold(currentNft, userAddress);
        setLoader(false);
      } else if (
        currentNft.chain === "Polygon" &&
        window.ethereum.networkVersion === "80001" // change chainid for mainnet over here
      ) {
        console.log("Logic for Polygon!!");
        const account = await web3.eth.getAccounts();
        console.log(account);
        const Marketcontractpoly = new web3.eth.Contract(
          Market,
          "0xbCd34790cCad22c47C3258b16bA1f1280f6cFF7e"
        );
        console.log(Marketcontractpoly.methods);
        const price = maticToWei(price);
        console.log(price);
        // await TOKEN_Contract.methods
        //   .approve("0xbCd34790cCad22c47C3258b16bA1f1280f6cFF7e", price) // market contract address will be changed over here for mainnet
        //   .send({ from: `${account[0]}` });
        console.log(currentNft.tokenid);
        const transaction = await Marketcontractpoly.methods
          .createMarketSale(
            "0x0Fb706c7Cd20d17Bd27914236bEde35DE2a648eb",
            parseInt(currentNft.tokenid)
          )
          .send({ from: `${account[0]}` });

        console.log(transaction);
        setNftSold(currentNft, userAddress);
        setLoader(false);
      } else {
        alert(
          "Wrong network. Please connect your wallet to the right network."
        );
        setLoader(false);
      }
      // loadNFTs()
    } catch (er) {
      console.log(er);
      setLoader(false);
    }
  };

  const stopMovie = (e) => {
    e.target.pause();
  };

  useEffect(() => {
    console.log("NFTDetail =>", NFTDetail);
  }, [NFTDetail]);
  const playMovie = (e) => {
    e.target.play();
  };
  let dispatch = useDispatch();
  const menus = ["left"];
  const { isConnected, user } = useSelector((state) => {
    return state[authFeatureKey];
  });
  const isNFTLiked = (docId) => {
    if (isConnected) {
      const isLiked = user.likedNft.find((nft) => nft === docId);
      if (isLiked) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  let likeNft = (docID, e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isConnected) {
      if (isNFTLiked(docID)) {
        setSpinner(true);
        setTimeout(() => {
          setSpinner(false);
          setLikes(likes - 1);
        }, 2000);
        dispatch(authActions.dislikeCard(docID, currentUser));
      } else {
        setSpinner(true);
        setTimeout(() => {
          setSpinner(false);
          setLikes(likes + 1);
        }, 2000);
        dispatch(authActions.likeCard(docID, currentUser));
      }
    }
  };
  return (
    <section className="singlenft-wrapper">
      {loader && <PreloaderInner />}
      <div className="singlenft ">
        <div className="cards nft-cards-singlefit">
          <div className="card nft-card-singlenft">
            {NFTDetail &&
            NFTDetail.imageUrl &&
            NFTDetail.imageUrl.indexOf("mp4") > -1 ? (
              <video
                onMouseOver={playMovie}
                onMouseOut={stopMovie}
                preload="none"
                className="nftImg-singlenft"
                src={NFTDetail.imageUrl}
                loop
              >
                Your browser does not support the video tag.
              </video>
            ) : (
              <img
                src={NFTDetail && NFTDetail.imageUrl}
                alt="Card"
                className="nftImg-singlenft"
              />
            )}
          </div>
        </div>
        <div className="singlenft-details ">
          <h2>{NFTDetail && NFTDetail.name}</h2>
          <p class="singlenftText">{NFTDetail && NFTDetail.description}</p>
          <p className="cLine">
            <span style={{ color: "white" }}>
              created by{" "}
              <Link to="/profile">
                <span className="yellow">@{username}</span>
              </Link>
            </span>
            <span style={{ color: "white" }}>
              <Stack direction="row" alignItems="center" gap={1}>
                <RemoveRedEyeOutlinedIcon style={{ fontSize: "15px" }} />
                <Typography style={{ fontSize: "13px" }} variant="body1">
                  {views}
                </Typography>
                <FavoriteBorderIcon style={{ fontSize: "15px" }} />
                <Typography style={{ fontSize: "13px" }} variant="body1">
                  {likes}
                </Typography>
              </Stack>
            </span>
          </p>
          <div className="tags">
            {NFTDetail &&
              NFTDetail.tags &&
              NFTDetail.tags.map((data) => <p className="tag">{data}</p>)}
          </div>
          <div className="singlenft-price">
            {NFTDetail.chain === "Ethereum" ? (
              <img src={ethereum} alt="ethereum" />
            ) : (
              <img src={polygon} alt="polygon" />
            )}
            <h3>{NFTDetail && NFTDetail.price}</h3>
            {NFTDetail && NFTDetail.price && (
              <p>
                ($
                {NFTDetail.chain === "Ethereum"
                  ? (
                      (NFTDetail.price - NFTDetail.price * (2.5 / 100)) *
                      ls.get("eth-usd")
                    ).toFixed(2)
                  : (
                      (NFTDetail.price - NFTDetail.price * (2.5 / 100)) *
                      ls.get("matic-usd")
                    ).toFixed(2)}
                )
              </p>
            )}
          </div>
          {NFTDetail.ownerAddress !== currentUser && (
            <div className="singlenft-buttons">
              {!hideBuyNowIfCreator() && (
                <button
                  onClick={() => buyNFT(NFTDetail)}
                  className="button-white"
                >
                  Buy Now
                </button>
              )}
            </div>
          )}
        </div>
        <div className="side-icons">
          {spinner ? (
            <div className="side-icon" style={{ padding: "15px" }}>
              <ClipLoader loading={spinner} color={"#d3aa4b"} size={18} />
            </div>
          ) : isNFTLiked(NFTDetail.docID) ? (
            <FavoriteIcon
              className="side-icon liked-heart-icon"
              style={{ padding: "16px 14px" }}
              onClick={likeNft.bind(this, NFTDetail.docID)}
            />
          ) : (
            <FavoriteBorderIcon
              className="side-icon "
              onClick={likeNft.bind(this, NFTDetail.docID)}
            />
          )}

          <SendRoundedIcon className="side-icon" />
          <div>
            {menus.map((direction) => (
              <Menu
                menuButton={<ShareIcon className="side-icon" />}
                key={direction}
                direction={direction}
                align={align}
                position={position}
                viewScroll={viewScroll}
                arrow={display === "arrow"}
                offsetX={
                  display === "offset" &&
                  (direction === "left" || direction === "right")
                    ? 12
                    : 0
                }
                offsetY={
                  display === "offset" &&
                  (direction === "top" || direction === "bottom")
                    ? 12
                    : 0
                }
              >
                <MenuItem
                  onClick={(e) => {
                    copy(shareUrl);
                    toast.success("Link Copied Successfully");
                  }}
                >
                  <div className="option-container">
                    <div className="icon-box">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="size-of-icon"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                        <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
                      </svg>
                    </div>
                    <div className="option-text">Copy Link</div>
                  </div>
                </MenuItem>
                <MenuItem>
                  <FacebookShareButton
                    url={"https://www.youtube.com"}
                    title={NFTDetail && NFTDetail.name}
                  >
                    <div className="option-container">
                      <div className="icon-box">
                        <FacebookIcon size={"1.5rem"} />
                      </div>
                      <div className="option-text">Share on Facebook</div>
                    </div>
                  </FacebookShareButton>
                </MenuItem>
                <MenuItem>
                  <TwitterShareButton
                    url={shareUrl}
                    title={NFTDetail && NFTDetail.name}
                  >
                    <div className="option-container">
                      <div className="icon-box">
                        <TwitterIcon size={"1.5rem"} />
                      </div>
                      <div className="option-text">Share on Twitter</div>
                    </div>
                  </TwitterShareButton>
                </MenuItem>
              </Menu>
            ))}
          </div>
          <PersonOutlineOutlinedIcon className="side-icon" />
          <ReportProblemOutlinedIcon className="side-icon" />
        </div>
      </div>
    </section>
  );
}

export default SingleNFTInfluencer;
